import { z } from "zod";
import {
  actionsMapSchema,
  createEmptyCriteria,
  orchestratedEntityBaseSchema,
} from "../../shared/domain/orchestratedEntity.schema";

export const GlobalActionsConfigSchema = z.object({
  ...orchestratedEntityBaseSchema,
  actions: actionsMapSchema,
});

export type GlobalActionsConfigInput = z.input<typeof GlobalActionsConfigSchema>;
export type GlobalActionsConfigEntity = z.output<typeof GlobalActionsConfigSchema>;

export function createEmptyGlobalActionsConfig(id: string): GlobalActionsConfigEntity {
  return {
    id,
    active: true,
    ticker: "",
    actions: {},
    criteria: createEmptyCriteria(),
  };
}
